/**
 * TimelineEvent.tsx - TimelineEvent - Individual event card
 * 
 * CHANGE HISTORY:
 * - 251021_0607 [8c824de] danielbeer: feat(inspectr): migrate to TypeScript
 * - 251021_0438 [46df53c] danielbeer: feat: complete comprehensive package migration to full standards
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';

const TimelineEvent = ({ event, getField, updateItem, isSelected, onSelect, side, showMilestone }) => {
  const name = getField(event, 'name') || 'Untitled Event';
  const description = getField(event, 'description') || '';
  const date = new Date(getField(event, 'startDate') || getField(event, 'createdAt'));
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  const color = getField(event, 'color') || '#4f46e5 /* TODO: Replace with Skinnr variable */ /* TODO: Replace with Skinnr variable */';
  const icon = getField(event, 'icon');
  
  return (
    <div className={`timeline-event side-${side} ${isSelected ? 'selected' : ''} ${showMilestone ? 'milestone' : ''}`} onClick={onSelect}>
      <div className="timeline-event-marker" style={{ backgroundColor: color }}>
        {showMilestone ? '◆' : icon || '●'}
      </div>
      
      <div className="timeline-event-card">
        <div className="timeline-event-time">{time}</div>
        <h4 className="timeline-event-title">{name}</h4>
        {description && <p className="timeline-event-description">{description}</p>}
      </div>
    </div>
  );
};

export default TimelineEvent;
